import React, {useState, useEffect} from "react"
import { Link } from "react-router-dom"
import { FabricJSCanvas, useFabricJSEditor } from "fabricjs-react"

const SrNo = cell => {
  return (
    <Link to="#" className="text-body fw-bold">
      {cell.value ? cell.value : ""}
    </Link>
  )
}


const Design = ({ cell }) => {
  return cell.value ? cell.value : ""
};



const DesignName = cell => {
  return cell.value ? cell.value : ""
}

const DesignDescription = cell => {
  return cell.value ? cell.value : ""
}



export { SrNo, Design, DesignName, DesignDescription }